import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

const EXCLUDED_URL_PATTERNS: string[] = [
  'main-categories',
];

export const transferStateInterceptor: HttpInterceptorFn = (req, next) => {
  const transferState = inject(TransferState);
  const platformId = inject(PLATFORM_ID);

  // Only cache GET requests
  if (req.method !== 'GET') {
    return next(req);
  }

  // Skip caching for excluded URLs (always hit the network for these)
  const isExcluded = EXCLUDED_URL_PATTERNS.some((pattern) =>
    req.url.includes(pattern)
  );
  if (isExcluded) {
    return next(req);
  }

  // Create a unique key for this request
  const key = makeStateKey<any>('http_' + req.urlWithParams);

  // On browser, check if we have cached data from server
  if (isPlatformBrowser(platformId)) {
    const cachedResponse = transferState.get(key, null);
    if (cachedResponse) {
      // Remove the key after reading to prevent memory leaks
      transferState.remove(key);
      // Return cached response
      return of(new HttpResponse({ body: cachedResponse, status: 200 }));
    }
  }

  // On server or no cache, make the actual request
  return next(req).pipe(
    tap((event) => {
      // Store successful responses on server
      if (isPlatformServer(platformId) && event instanceof HttpResponse) {
        transferState.set(key, event.body);
      }
    })
  );
};